/* eslint-disable */
import React, { CSSProperties, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SaudiReyalSymbolIcon } from '../../img';
import longdash from '~/constants/longdash';
import { Amount } from '~/types/Amount';
import Tag from '../Tag';

interface Props {
  amount: Amount | undefined | null;
  className?: string;
  abs?: boolean;
  maximumFractionDigits?: number;
  alwaysShowDecimalPart?: boolean;
  style?: CSSProperties;
  tag?: boolean;
  id?: string;
  isMobile?: boolean;
}

const AmountField: FC<Props> = (props) => {
  const {
    amount,
    className,
    abs,
    maximumFractionDigits = 3,
    alwaysShowDecimalPart,
    style,
    tag,
    id,
    isMobile

  } = props;
  const { i18n } = useTranslation();
  const language = i18n.language.slice(0, 2);
  const hasDecimalPart = String(amount?.value || 0).includes('.');
const {t} = useTranslation('fillApplication')
  const amountText = getAmountText({
    amount,
    language,
    abs,
    maximumFractionDigits: !hasDecimalPart && !alwaysShowDecimalPart ? 0 : maximumFractionDigits,
  });

  if (tag)
    return (
      <>
        <SaudiReyalSymbolIcon style={{ marginRight: 4 }} />
        <Tag id={id} className={`AmountField ${className || ''}`} style={style} color="blue">
          {amountText}
        </Tag>
      </>
    );
  return (
      amount?.value ?  <>
      <SaudiReyalSymbolIcon style={{ marginRight: 4 }} />
      <span id={id} className={`AmountField ${className || ''}`} style={style}>
        {amountText}
      </span>
    </>:t('Free')
  );
};

export const getAmountText = (props: {
  amount?: Amount | null;
  language?: string;
  abs?: boolean;
  maximumFractionDigits?: number;
}): string => {
  const { amount, language, abs, maximumFractionDigits } = props;
  let amountText: string = longdash;
  if (!amount || (amount.value !== 0 && !amount.value) || !amount.currency) {
    amountText = longdash;
  } else if (amount.currency.toUpperCase() === 'SAR') {
    // The toLocaleString function uses the ISO 4217 currency codes and "FILS" is not a standard code in this system.
    const value = abs ? Math.abs(amount.value) : amount.value;
    amountText = `${value.toLocaleString(language ?? 'en')}`;
  } else {
    const value = abs ? Math.abs(amount.value) : amount.value;
    amountText = value
      .toLocaleString(language || 'en', {
        style: 'currency',
        currency: amount.currency,
        maximumFractionDigits,
      })
      .replace(new RegExp(String.fromCharCode(160), 'g'), ' '); // remove &nbsp; from string
  }
  return amountText;
};

export default React.memo(AmountField);
